import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Square,SquareCheckBig, X } from "lucide-react";
import { format } from 'date-fns';
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalAddEvent from '../components/ModalAddEvent';
import ModalAddBank from '../components/ModalAddBank';
import ModalAddVendor from '../components/ModalAddVendor';
import ModalAddPic from '../components/ModalAddPic';
import Swal from 'sweetalert2';
import MyDropzone from '../components/MyDropzone';
import Select from 'react-select';

export default function UpdateRf() {
    
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const storedUser = JSON.parse(localStorage.getItem("user"));
  const email = storedUser?.email;

  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
   
  const [nominals, setNominals] = useState([{ note: '', value: '' }]);

  const [events, setEvents] = useState([]);
  const [pic, setPics] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [bank, setBank] = useState([]);
  const [approvals, setApprovals] = useState([]);
  const [dpOptions, setDpOptions] = useState([]);
  const [filteredDpOptions, setFilteredDpOptions] = useState([]); 
  const [openEventModal, setOpenEventModal] = useState(false);
  const [openBankModal, setOpenBankModal] = useState(false);
  const [openVendorModal, setOpenVendorModal] = useState(false);
  const [openPicModal, setOpenPicModal] = useState(false);
  
  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
        const [
        eventRes,
        picRes,
        vendorRes,
        bankRes,
        rfRes,
        ] = await Promise.all([
        fetch(`${process.env.REACT_APP_BASE_URL}api/events`).then(res => res.json()),
        fetch(`${process.env.REACT_APP_BASE_URL}api/pic`).then(res => res.json()),
        fetch(`${process.env.REACT_APP_BASE_URL}api/vendors`).then(res => res.json()),
        fetch(`${process.env.REACT_APP_BASE_URL}api/bank`).then(res => res.json()),
        fetch(`${process.env.REACT_APP_BASE_URL}api/rf/filterEvent`).then(res => res.json()),
        ]);

        setEvents(eventRes);
        setPics(picRes);
        setVendors(vendorRes);
        setBank(bankRes);
        setDpOptions(rfRes);
    } catch (error) {
        console.error("Failed to fetch options:", error);
    }
  };

    useEffect(() => {
        const fetchApprovals = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/approval`); 
            const data = await res.json();

            const list = Array.isArray(data) ? data : data.data || [];
            setApprovals(list);
        } catch (err) {
            console.error("Gagal mengambil data approvals:", err);
        }
        };

        fetchApprovals();
    }, []);

    const [form, setForm] = useState({
        id: id,
        type: "",
        event_id: "",
        pic_id: '',
        vendor_id: '',
        bank_id: '',
        note: '',
        note2: '',
        note3: '',
        note4: '',
        note5: '',
        total: '',
        total2: '',
        total3: '',
        total4: '',
        total5: '',
        request_date: new Date(),
        notes: '',
        approvals: { one: '', two: '' },
        attachments: [],
        dp1: '',
        dp2: '',
        nilai_dp1: '',
        nilai_dp2: '',
        tgl_dp1: '',
        tgl_dp2: '',
        dp1_tgl: '',
        dp2_tgl: '',
        user_input: email,
    }); 

     // handle file upload (langsung update form.attachments)
    const handleAttachmentChange = (files) => {
        const previewUrls = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        setForm((prev) => ({
            ...prev,
            attachments: previewUrls,
        }));
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`)
        .then(res => res.json())
            .then(result => {
             setForm(prev => ({
                ...prev, // biar state lain tetap aman
                ...result.data, // isi dari API
                request_date: result.data.request_date
                ? new Date(result.data.request_date)
                : new Date()
            }));
        })
        .catch((err) => {
            console.error(err);
        });
    }, [id]);

    useEffect(() => {
        if (form.event && form.id_event) {
        setEventSearch(`- ${form.event}`);
        }
    }, [form.event, form.id_event]);
    
    useEffect(() => {
        if (form.id_bank) {
            setBankSearch(`${form.bank} ${form.no_rek} a/n ${form.atas_nama}`);
        }
    }, [form.bank, form.id_bank]);

    useEffect(() => {
        if (form.id_vendor) {
            setVendorSearch(`- ${form.vendor}`);
        }
    }, [form.id_vendor, form.vendor]);

    useEffect(() => {
        if (form.id_pic) {
            setPicSearch(`- ${form.pic}`);
        }
    }, [form.id_pic, form.pic]);

    const handleChangeNote = (index, field, value) => {
        setNote(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };

    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();

    data.append("notes", form.notes);

    Object.entries(form).forEach(([key, value]) => {
      if (key === 'attachments') {
        value.forEach(att => data.append('attachments[]', att.file));
      } else if (key === 'request_date') {
        data.append(key, value.toISOString().split("T")[0]);
      } else if (typeof value === 'object' && value !== null) {
        Object.entries(value).forEach(([k, v]) => {
          data.append(`${key}[${k}]`, v);
        });
      } else {
        data.append(key, value);
      }
    });

    note.forEach((item, index) => {
        data.append(`items[${index}][id]`, item.id || ""); // kalau update
        data.append(`items[${index}][note]`, item.note);
        data.append(`items[${index}][total]`, item.total);
    });

    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/rf/updaterf`, {
        method: "POST",
        body: data,
        });

        if (!response.ok) {
        const errorData = await response.json();
        console.log("yang tersubmit:",data)
        throw new Error(errorData.message || "Submit failed");
        }
        console.log("yang tersubmit:",data)
        await Swal.fire({
            title: 'Berhasil',
            text: 'Form berhasil dikirim!',
            icon: 'success',
            confirmButtonText: 'OK'
        });
        navigate("/");
    } catch (error) {
        console.error("Error submitting form:", error);
        alert("Error submitting form: " + error.message);
    }
  };

    // search event
  const [eventSearch, setEventSearch] = useState('');
  const [eventSuggestions, setEventSuggestions] = useState([]);
  // search bank account
  const [bankSearch, setBankSearch] = useState('');
  const [bankSuggestions, setBankSuggestions] = useState([]);
  // search vendor account
  const [vendorSearch, setVendorSearch] = useState('');
  const [vendorSuggestions, setVendorSuggestions] = useState([]);
  // search pic
  const [picSearch, setPicSearch] = useState('');
  const [picSuggestions, setPicSuggestions] = useState([]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
        if (eventSearch.length > 1) {
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/events/search?query=${eventSearch}`)
            .then(res => setEventSuggestions(res.data))
            .catch(() => setEventSuggestions([]));
        } else {
        setEventSuggestions([]);
        }
    }, 500); // debounce
    return () => clearTimeout(delayDebounce);
  }, [eventSearch]);

  useEffect(() => {
    const delayDebounce2 = setTimeout(() => {
        if (bankSearch?.length > 1) {
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/bank/search?query=${bankSearch}`)
            .then(res => setBankSuggestions(res.data))
            .catch(() => setBankSuggestions([]));
        } else {
        setBankSuggestions([]);
        }
    }, 300); // debounce
    return () => clearTimeout(delayDebounce2);
  }, [bankSearch]);

  useEffect(() => {
    const delayDebounce3 = setTimeout(() => {
        if (vendorSearch?.length > 1) {
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/vendors/search?query=${vendorSearch}`)
            .then(res => setVendorSuggestions(res.data))
            .catch(() => setVendorSuggestions([]));
        } else {
        setVendorSuggestions([]);
        }
    }, 300); // debounce
    return () => clearTimeout(delayDebounce3);
  }, [vendorSearch]);

  useEffect(() => {
    const delayDebounce4 = setTimeout(() => {
        if (picSearch?.length > 1) {
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/pic/search?query=${picSearch}`)
            .then(res => setPicSuggestions(res.data))
            .catch(() => setPicSuggestions([]));
        } else {
        setPicSuggestions([]);
        }
    }, 300); // debounce
    return () => clearTimeout(delayDebounce4);
  }, [picSearch]);

  const formatNumber = (value) => {
    if (!value) return "";
        return new Intl.NumberFormat("id-ID").format(Number(value));
    };

    // Fungsi untuk membersihkan titik atau non-digit agar jadi angka murni
    const parseNumber = (formattedValue) => {
        return formattedValue.replace(/\D/g, "");
    };

    const handleNominalChange = (index, field, value) => {
        const newNominals = [...nominals];
        if (field === "value") {
        const raw = parseNumber(value);
        newNominals[index][field] = raw;
        } else {
        newNominals[index][field] = value;
        }
        setNominals(newNominals);
    };

    const addNominalRow = () => {
        setNominals([...nominals, { note: "", value: "" }]);
    };

    const getTotal = () => {
        return nominals.reduce((acc, curr) => acc + Number(curr.value || 0), 0);
    };
    
    const [previewData, setPreview] = useState(null);

    const handlePreview = () => {
        setPreview();
    };
   
    const [note, setNote] = useState([]);

    useEffect(() => {
        const fetchNote = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/note/search?query=${id}`);
                
                if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
                }

                const note = await res.json();
                const list = Array.isArray(note) ? note : note.data || [];

                console.log("Data Note:", list);
                setNote(list);
            } catch (err) {
                console.error("Gagal mengambil data note:", err);
            }
            };
        fetchNote();
    }, []);

    const options = filteredDpOptions.map((dp) => ({
        value: dp.id,
        label: `${dp.total 
            ? dp.note 
            : dp.notenote} - ${new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
            }).format(dp.total ? dp.total : dp.totalnote)}`,
        total: dp.total ? dp.total : dp.totalnote,
        created_at: dp.created_at,
        input_date: dp.input_date,
        }));

  return (
    <div className="max-w-full mx-auto p-2">
        <div className="max-w-full mx-auto mt-2 p-4 bg-white rounded shadow">
            <form onSubmit={handleSubmit}>
                {/* Type */}
                <div className='flex flex-row gap-2 justify-between mb-4'>
                    <div className='flex flex-col md:w-1/4'>
                        <select
                        name='type'
                        className="w-full border p-2 rounded"
                        value={form.type}
                        onChange={handleChange}
                            >
                            <option value="">Pilih Tipe Ajuan</option>
                            <option value="um">Permintaan Uang Muka</option>
                            <option value="reimburse">Reimbursement</option>
                            <option value="dp">DP ke Vendor/Talent</option>
                            <option value="pelunasan">Pelunasan ke Vendor/Talent</option>
                        </select>
                    </div>
                    <div className='flex flex-col md:w1/4'>
                        <Link
                            to="/">
                            <button
                                className="w-full bg-black/100 text-left py-2 px-4 rounded text-white hover:bg-gray-700 flex justify-between items-center"
                                >
                                Kembali ke List Ajuan
                            </button>
                        </Link>
                    </div>
                </div>
                <div className='flex flex-row gap-2 mb-4'>
                    {/* Event */}
                    <div className='flex flex-col md:w-1/2'>
                        <div className="flex-1">
                            <label className="block mb-1">Event </label>
                            <div className='flex flex-row gap-2'>
                                <input
                                    type="text"
                                    name='event_id'
                                    className="w-full border p-2 rounded"
                                    value={eventSearch}
                                    onChange={(e) => {
                                    setEventSearch(e.target.value);
                                    setForm({ ...form, event_id: '' }); 
                                    }}
                                    placeholder="Ketik nama event"
                                />
                                {eventSuggestions.length > 0 && (
                                    <div
                                        className="absolute z-10 bg-white border mt-11 border-gray-300 rounded shadow-md"
                                        style={{
                                            maxHeight: "200px", // tinggi maksimal sebelum muncul scroll
                                            overflowY: "auto",
                                            width: "auto",
                                        }}
                                    >
                                        <ul>
                                        {eventSuggestions.map((ev) => (
                                            <li
                                            key={ev.id}
                                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                            onClick={async () => {
                                            setEventSearch(`${ev.name}`);
                                            setForm({ ...form, event_id: ev.id, dp1: "", dp2: "" });
                                            setEventSuggestions([]);
                                                try {
                                                    const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/rf/filterEvent?id_event=${ev.id}`);
                                                    const data = await res.json();
                                                    setFilteredDpOptions(data);
                                                } catch (err) {
                                                    console.error("Gagal fetch DP", err);
                                                    setFilteredDpOptions([]);
                                                }
                                            
                                            }}

                                            >
                                                {ev.name}
                                            </li>
                                        ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Bank */}
                    <div className='flex flex-col md:w-1/2'>
                        <div className="flex-1">
                            <label className="block mb-1">Akun Bank</label>
                            <div className='flex flex-row gap-2'>
                                <input
                                    type="text"
                                    className="w-full border p-2 rounded"
                                    value={bankSearch}
                                    onChange={(e) => {
                                    setBankSearch(e.target.value);
                                    setForm({ ...form, bank_id: '' }); 
                                    }}
                                    placeholder="Ketik nama bank, atas nama atau nomor rekening"
                                />
                                {bankSuggestions.length > 0 && (
                                    <div
                                        className="absolute z-10 bg-white border mt-11 border-gray-300 rounded shadow-md"
                                        style={{
                                            maxHeight: "200px", // tinggi maksimal sebelum muncul scroll
                                            overflowY: "auto",
                                            width: "auto",
                                        }}
                                    >
                                        <ul>
                                        {bankSuggestions.map((ba) => (
                                            <li
                                            key={ba.id}
                                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                            onClick={() => {
                                                setBankSearch(`${ba.bank} ${ba.no_rek} a/n ${ba.atas_nama}`);
                                                setForm({ ...form, bank_id: ba.id});
                                                setBankSuggestions([]);
                                            }}
                                            >
                                            {ba.bank} {ba.no_rek} a/n {ba.atas_nama} 
                                            </li>
                                        ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='flex flex-row gap-2 mb-4'>
                    {/* Vendor */}
                    <div className='flex flex-col md:w-1/2'>
                        <div className="flex-1">
                            <label className="block mb-1">Vendor</label>
                            <div className='flex flex-row gap-2'>
                                <input
                                    type="text"
                                    className="w-full border p-2 rounded"
                                    value={vendorSearch}
                                    onChange={(e) => {
                                    setVendorSearch(e.target.value);
                                    setForm({ ...form, vendor_id: '' }); 
                                    }}
                                    placeholder="Ketik nama Vendor"
                                />
                                {vendorSuggestions.length > 0 && (
                                    <ul className="absolute z-10 bg-white border rounded mt-11 overflow-y-auto">
                                    {vendorSuggestions.map((ve) => (
                                        <li
                                        key={ve.id}
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        onClick={() => {
                                            setVendorSearch(`- ${ve.name}`);
                                            setForm({ ...form, vendor_id: ve.id });
                                            setVendorSuggestions([]);
                                        }}
                                        >
                                        {ve.name}
                                        </li>
                                    ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Bank */}
                    {/* <div className='flex flex-col md:w-1/2'>
                        <div className="flex-1">
                            <label className="block mb-1">PIC</label>
                            <div className='flex flex-row gap-2'>
                                <input
                                    type="text"
                                    className="w-full border p-2 rounded"
                                    value={picSearch}
                                    onChange={(e) => {
                                    setPicSearch(e.target.value);
                                    setForm({ ...form, pic_id: '' }); 
                                    }}
                                    placeholder="Ketik nama PIC"
                                />
                                {picSuggestions.length > 0 && (
                                    <ul className="absolute z-10 bg-white border rounded mt-11 overflow-y-auto">
                                    {picSuggestions.map((pi) => (
                                        <li
                                        key={pi.id}
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        onClick={() => {
                                            setPicSearch(`- ${pi.name}`);
                                            setForm({ ...form, pic_id: pi.id});
                                            setPicSuggestions([]);
                                        }}
                                        >
                                        {pi.name} | {pi.username}
                                        </li>
                                    ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div> */}
                </div>                

                {/* Date */}
                <div>
                    <label className="block">Request Payment Date</label>
                    <DatePicker
                    selected={form.request_date}
                    onChange={(date) => setForm({ ...form, request_date: date })}
                    className="border p-2 rounded w-full"
                    />
                </div>

                {/* Notes & Nominal */}
                <div className='mb-4'>
                    <label className="font-semibold">Item</label>
                    {!form.note ? (   
                        Array.isArray(note) && note.map((a, idx) => (
                            <div className="flex gap-2 mb-2">
                                <textarea
                                    placeholder="Keterangan"
                                    className="border p-2 w-1/2 rounded"
                                    value={a.note}
                                    onChange={(e) => handleChangeNote(idx, "note", e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder="Total"
                                    className="border p-2 w-1/3 rounded text-right"
                                    value={a.total === null || a.total === undefined ? "" : formatNumber(a.total)}
                                    onChange={(e) => {
                                        // Ambil hanya digit
                                        const raw = e.target.value.replace(/\D/g, "");
                                        // Convert ke number, kalau kosong jadikan 0
                                        const numericValue = raw === "" ? 0 : Number(raw);
                                        // Simpan ke state
                                        handleChangeNote(idx, "total", numericValue);
                                    }}
                                    
                                />
                                <input
                                    type="hidden"
                                    placeholder="Total"
                                    className="border p-2 w-1/3 rounded text-right"
                                    value={formatNumber(a.id)}
                                    onChange={(e) => handleChangeNote(idx, "id", e.target.value)}
                                />
                            </div>
                            
                        ))
                        ) : (
                        <>
                            {["note", "note2", "note3", "note4", "note5"].map(
                            (field, idx) =>
                                form[field] && (
                                <div key={idx} className="flex gap-2 mb-2">
                                    <textarea
                                    placeholder={`Keterangan ${field}`}
                                    className="border p-2 w-1/2 rounded"
                                    value={form[field]}
                                    onChange={(e) =>
                                        setForm({ ...form, [field]: e.target.value })
                                    }
                                    />
                                    <input
                                    type="text"
                                    placeholder="Total"
                                    className="border p-2 w-1/3 rounded text-right"
                                    value={(form[`total${idx === 0 ? "" : idx + 1}`])}
                                    onChange={(e) => {
                                        // Ambil hanya angka mentah
                                        const raw = e.target.value.replace(/\D/g, "");

                                        // Simpan angka mentah (integer, tanpa titik/koma) ke state
                                        setForm({
                                        ...form,
                                        [`total${idx === 0 ? "" : idx + 1}`]: raw ? parseInt(raw, 10) : "",
                                        });
                                    }}
                                    />
                                </div>
                                )
                            )}
                        </>
                    )}
                    
                </div>

                {/* Approval */}
                <div className="grid grid-cols-2 gap-2">
                    <div>
                        <label>Approval 1</label>
                        <select
                        className="w-full border p-2 rounded"
                        value={form.approvals.one}
                        onChange={(e) =>
                            setForm({
                            ...form,
                            approvals: { ...form.approvals, one: e.target.value },
                            })
                        }
                        >
                        <option value={form.approval_1}>{form.approval_1}</option>
                        {Array.isArray(approvals) &&
                            approvals.map((a) => (
                            <option key={a.id} value={a.name}>
                                {a.name}
                            </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label>Approval 2</label>
                        <select
                        className="w-full border p-2 rounded"
                        value={form.approvals.two}
                        onChange={(e) =>
                            setForm({
                            ...form,
                            approvals: { ...form.approvals, two: e.target.value },
                            })
                        }
                        >
                        <option value={form.approval_2}>{form.approval_2}</option>
                        <option value="">{form.approvals.one}</option>
                        {Array.isArray(approvals) &&
                            approvals.map((a) => (
                            <option key={a.id} value={a.name}>
                                {a.name}
                            </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Upload */}
                {/* <div>
                    <label>Attachments</label>
                    <input
                    type="file"
                    multiple
                    onChange={handleAttachmentChange}
                    className="w-full border p-2 rounded"
                    />
                </div> */}

                {/* DP1 & DP2 */}
                <div className="grid grid-cols-2 gap-2">
                    <div>
                    <label>Down Payment 1</label>
                        <Select
                            className="w-full text-sm"
                            classNames={{
                                control: () => 'border rounded-md shadow-sm hover:border-gray-400',
                                option: ({ isFocused }) =>
                                isFocused ? 'bg-blue-100 text-blue-900' : 'bg-white text-gray-800',
                            }}
                            placeholder="Pilih DP"
                            options={options}
                            value={options.find((opt) => opt.value === form.dp1) || null}
                            onChange={(selected) => {
                                setForm({
                                ...form,
                                dp1: selected?.value ?? '',
                                nilai_dp1: selected?.total ?? selected?.totalnote ?? 0,
                                dp1_tgl: selected?.created_at ?? selected?.input_date ?? '',
                                });
                            }}
                            isClearable
                            isSearchable
                            menuPlacement="auto" 
                            menuPosition="fixed"
                            />
                    </div>
                    <div>
                    <label>Down Payment 2</label>
                        <Select
                            className="w-full text-sm"
                            classNames={{
                                control: () => 'border rounded-md shadow-sm hover:border-gray-400',
                                option: ({ isFocused }) =>
                                isFocused ? 'bg-blue-100 text-blue-900' : 'bg-white text-gray-800',
                            }}
                            placeholder="Pilih DP"
                            options={options}
                            value={options.find((opt) => opt.value === form.dp2) || null}
                            onChange={(selected) => {
                                setForm({
                                ...form,
                                dp2: selected?.value ?? '',
                                nilai_dp2: selected?.total ?? selected?.totalnote ?? 0,
                                dp2_tgl: selected?.created_at ?? selected?.input_date ?? '',
                                });
                            }}
                            isClearable
                            isSearchable
                            menuPlacement="auto" 
                            menuPosition="fixed"
                            />
                    </div>
                </div>
                {/* Upload */}
                <div className='gap-2 mt-4'>
                    <label>Bukti Approval dan Dokumen Pendukung lainnya (PO, Faktur Pajak, dll)</label>
                    <MyDropzone handleAttachmentChange={handleAttachmentChange} />
                </div>

                <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded mt-4">Simpan</button>
            </form>
        </div>
        <ModalAddEvent
        isOpen={openEventModal}
        onClose={() => setOpenEventModal(false)}
        onAdded={(newEvent) => setEvents([...events, newEvent])}
        />
        <ModalAddBank
        isOpen={openBankModal}
        onClose={() => setOpenBankModal(false)}
        onAdded={(newBank) => setBank([...bank, newBank])}
        />
        <ModalAddVendor
        isOpen={openVendorModal}
        onClose={() => setOpenVendorModal(false)}
        onAdded={(newVendors) => setVendors([...vendors, newVendors])}
        />
        <ModalAddPic
        isOpen={openPicModal}
        onClose={() => setOpenPicModal(false)}
        onAdded={(newPic) => setPics([...pic, newPic])}
        />
        
    </div>
  );
}
